/* This example requires Tailwind CSS v2.0+ */
import React from 'react';
import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import {
  Section,
  Container,
  Col,
  Grid,
  SanityBlockContent,
} from '../../common';

const StyledIcon = styled.div`
  color: ${(props) => props.$color};
`;

const StyledSVG = styled(SVG)`
  fill: ${(props) => props.$fillColor};
`;

const BenefitsOverview = ({ sanity, page, section }) => {
  const { colors, benefits } = sanity;
  const { list } = section;

  const iconComponents = list?.items
    ?.sort((a, b) => a?.order - b?.order)
    ?.map((item, index) => {
      if (list?.items?.length >= 5) {
        return (
          <Col
            key={index}
            classes="pt-6 relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-0 text-left"
          >
            <div className="flex items-center justify-start">
              <StyledIcon className="mr-4 h-8 w-8">
                <StyledSVG
                  src={item?.media?.asset?.url}
                  alt={item?.media?.alt}
                  className="h-full w-full object-cover transition hover:scale-105"
                  $fillColor={colors?.accent?.default}
                />
              </StyledIcon>
              <h2 className="text-lg font-medium">{item?.title}</h2>
            </div>
            <p className="mb-8 mt-5 text-base text-zinc-500">
              <SanityBlockContent
                sanity={sanity}
                blocks={item?._rawDescription}
              />
            </p>
          </Col>
        );
      } else {
        return (
          <Col
            key={index}
            classes="pt-6 relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center"
          >
            <StyledIcon className="mx-auto h-32 w-32">
              <StyledSVG
                src={item?.media?.asset?.url}
                alt={item?.media?.alt}
                className="h-full w-full object-cover transition hover:scale-105"
                $fillColor={colors?.accent?.default}
              />
            </StyledIcon>
            <div className="relative z-10">
              <h2 className="mt-8 text-3xl font-medium">{item?.title}</h2>
              <p className="mb-8 mt-5 text-left text-lg text-zinc-500">
                <SanityBlockContent
                  sanity={sanity}
                  blocks={item?._rawDescription}
                />
              </p>
            </div>
          </Col>
        );
      }
    });

  const getGridColumnsClass = (length) => {
    if (length <= 3)
      return 'grid-cols-1 lg:grid-cols-3 lg:gap-x-12 lg:gap-y-0 gap-y-12';
    if (length === 4)
      return 'grid-cols-1 lg:grid-cols-4 lg:gap-x-12 lg:gap-y-0 gap-y-12';
    if (length >= 5)
      return 'grid-cols-1 lg:grid-cols-3 lg:gap-x-12 lg:gap-y-0 gap-y-12';
  };

  return (
    <Section
      idName="benefits-overview"
      padding="sm"
      bgColor={colors?.neutral?.light}
      h2Color={colors?.neutral?.darker}
      h3Color={colors?.primary?.dark}
      spanColor={colors?.accent?.light}
    >
      <Container
        padding="none"
        classes="max-w-md px-4 lg:px-0 sm:max-w-3xl lg:max-w-7xl"
      >
        <Grid classes={getGridColumnsClass(list?.items?.length)}>
          {iconComponents}
        </Grid>
      </Container>
    </Section>
  );
};

export { BenefitsOverview };
